<template>
<div class="bottomboxs">
  <div class="footerheight">
    <div class="footer-box">
      <div class="footer layui-container layui-clear">
        <div class="footer-left layui-clear fl">
          <div class="Mfooter">
            <dl class="footer-nav-list fl"
                v-show="footershow"
                v-for="(item,index) in footerList "
                :key="index">
              <dt class="title1">{{item.top}}
                <span @click='showchild(item,index)'
                      :class=" item.classid!=footershowid? 'footer-nav-btn' : 'footer-nav-btn on'"></span>

              </dt>

              <dd v-for="(items,indexs) in item.list "
                  :key="indexs"
                  v-show="items.parent_id==footershowid"><a :href="items.url"
                   class="text1">{{items.title}}</a></dd>
            </dl>
          </div>
          <div class="Pfooter">
            <dl class="footer-nav-list fl"
                v-show="footershow"
                v-for="(item,index) in footerList "
                :key="index">
              <dt class="title1">{{item.top}}<span class="footer-nav-btn"></span></dt>

              <dd v-for="(items,indexs) in item.list "
                  :key="indexs"><a :href="items.url"
                   class="text1">{{items.title}}</a></dd>
            </dl>
          </div>
        </div>
        <div class="footer-right fr">
          <div class="layui-clear">
            <div class="title1">全国服务电话</div>
            <div class="footer-tel text1">
              <p class="layui-clear"><span class="fr">{{footerTelList.value}}</span><img src="../assets/tel.png"
                     alt=""
                     class="fr"></p>
              <p>（服务时间：8:00-24:00）</p>
            </div>
          </div>
          <ul class="footer-code-list layui-clear">
            <li>
              <div class="footer-code"><img :src="shop_wechat.value"
                     alt=""></div>
              <div class="text1">官方微博二维码</div>
            </li>
            <li>
              <div class="footer-code"><img :src="shop_wbewm.value"
                     alt=""></div>
              <div class="text1">官方微信二维码</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="copyright-box">
      <div class="copyright layui-container layui-clear text1">
        <p class="fl">{{footerCopyrightList.value}} | </p>
        <a href="http://www.ni8.com/"
           rel="nofollow"
           title=""
           target="_blank"
           class="fl">网站设计</a>
        <a href="http://www.miitbeian.gov.cn/"
           title=""
           target="_blank"
           class="fr">{{shop_bah.value}}</a>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { getfooter, getfootermsg } from "@/api/api";
export default {
  data () {
    return {
      footerList: [],
      footershow: false,
      footershowid: '',
      footerTelList: '',
      footerCopyrightList: '',
      shop_wechat: '',
      shop_wbewm: '',
      shop_bah: '',
    };
  },
  created () {
    this.getfooterList()
    this.getfootermsgList()
  },
  mounted () {

  },
  methods: {
    getfootermsgList () {
      var para = {};
      getfootermsg(para).then(res => {
        if (res.data.error_code == 200) {

        //   console.log('获取成功', res.data)
          this.footerTelList = res.data.list[5]
          this.footerCopyrightList = res.data.list[6]
          this.shop_wechat = res.data.list[9]
          this.shop_wbewm = res.data.list[10]
          this.shop_bah = res.data.list[12]
        } else {
          console.info("请求失败", err);
        }
      }).catch(err => { console.info("调用失败", err); })
    },
    getfooterList () {
      var para = {};
      getfooter(para).then(res => {
        if (res.data.error_code == 200) {
          this.footerList = res.data.list
          this.footershow = true
        //   console.log('获取成功', res.data.list)

        } else {
          console.info("请求失败", err);
        }
      }).catch(err => { console.info("调用失败", err); })
    },

    showchild (item, index) {

      if (this.footershowid == item.classid) {
        this.footershowid = ''
      } else {
        this.footershowid = item.classid
      }
    }


  }
};
</script>

<style >
/* @import "../../static/newlayout.css"; */
@import "../../static/layui/css/layui.css";
/* footer */
/* a {
  display: block;
}
u {
  text-decoration: none;
} */
.footerheight {
  margin-top: 60px;
}
.footerheight a {
  display: block;
}
.footerheight u {
  text-decoration: none;
}
.text1 {
  font-size: 14px;
  line-height: 20px;
}
.title1 {
  color: #333;
  font-size: 18px;
  line-height: 24px;
  @include transition;
}
.footer-box {
  width: 100%;
  padding-top: 60px;
  padding-bottom: 60px;
  background-color: #202020;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.footer-box .title1 {
  color: #fff;
  margin-bottom: 15px;
}
.footer-box .text1 {
  color: #fff;
  opacity: 0.5;
}
.footer-box .footer-left {
  width: 70%;
  display: block;
}
.footer-box .footer-right {
  width: 25%;
  display: block;
}
.footer-box .footer-right .title1 {
  text-align: right;
}
.footer-box .footer-nav-list {
  width: 16.6%;
  text-align: center;
}
.footer-box .footer-nav-list dt {
  width: 100%;
  position: relative;
}
.footer-box .footer-nav-list dt .footer-nav-btn {
  width: 60px;
  height: 40px;
  display: none;
  background-image: url(../assets/off.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 10px;
  position: absolute;
  top: 0px;
  right: 0px;
}
.footer-box .footer-nav-list dt .footer-nav-btn.on {
  background-image: url(../assets/on.png);
}
.footer-box .footer-nav-list dd a {
  padding: 5px 0px;
}
.footer-box .footer-tel {
  text-align: right;
}
.footer-box .footer-tel p {
  margin-bottom: 5px;
}
.footer-box .footer-tel img {
  width: 16px;
  margin-right: 5px;
}
.footer-box .footer-code-list {
  margin-top: 15px;
}
.footer-box .footer-code-list li {
  width: auto;
  float: right;
  margin-right: 15px;
  text-align: center;
}
.footer-box .footer-code-list li:first-child {
  margin-right: 0px;
}
.footer-box .footer-code-list li .footer-code {
  width: 110px;
  padding: 5px;
  margin: 0px auto;
  overflow: hidden;
  margin-bottom: 5px;
  border-radius: 4px;
  background-color: #fff;
}
.footer-box .footer-code-list li .footer-code img {
  width: 100%;
}
.copyright-box {
  width: 100%;
  padding: 10px 0px;
  background-color: #202020;
}
.copyright-box p {
  color: #fff;
  opacity: 0.5;
  margin-right: 5px;
}
.copyright-box a {
  color: #fff;
  opacity: 0.5;
}
.Mfooter {
  display: none;
}
@media screen and (min-width: 992px) {
  .layui-btn-primary:hover {
    color: #fff;
    border-color: #e60012;
    background-color: #e60012;
  }

  .footer-box .footer-nav-list dd:hover a {
    opacity: 1;
  }
}

@media screen and (max-width: 991px) {
    .footerheight{margin-top: 0;}
  /* footer */
  .footer-box .footer-left,
  .footer-box .footer-right {
    width: 100%;
    float: none;
  }
  .footer-box .footer-right {
    margin-top: 20px;
  }
}
@media screen and (max-width: 767px) {
  .Mfooter {
    display: block;
  }
  .Pfooter {
    display: none;
  }
  .footer-right fr {
    display: block;
  }
  .title1 {
    font-size: 14px;
    line-height: 20px;
  }
  .heightF {
    width: 100%;
    height: 50px;
  }
  .bread,
  .page {
    display: none;
  }
  .loadMore {
    display: block;
  }
  .main {
    padding: 20px 0px;
  }
  .text1 {
    font-size: 12px;
  }

  /* footer */

  .footer-box,
  .footer {
    padding: 0px;
  }
  .footer-box {
    display: block;
  }
  .footer-box .footer-nav-list {
    width: 100%;
    float: none;
    text-align: left;
    display: block;
  }
  .footer-box .footer-nav-list dt {
    padding: 10px 15px;
    margin-bottom: 0px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
  .footer-box .footer-nav-list dt .footer-nav-btn {
    display: block;
  }
  .footer-box .footer-nav-list dd {
    /* display: none; */
    display: block;
  }
  .footer-box .footer-nav-list dd a {
    padding: 5px 30px;
  }
  .footer-box .footer-right {
    padding: 0px 15px;
  }
  .footer-box .footer-right .title1 {
    float: left;
  }
  .footer-box .footer-code-list {
    padding: 15px;
    margin-top: 0px;
  }
  .footer-box .footer-tel {
    float: right;
  }
  .footer-box .footer-tel p {
    margin-bottom: 0px;
  }
  .footer-box .footer-code-list li {
    width: 50%;
    margin-right: 0px;
  }
  .copyright-box {
    padding: 5px 0px;
  }
  .copyright-box a {
    float: left;
    margin-right: 5px;
  }
}
@media screen and (max-width: 767px) {
  /* .layui-container {
    width: 100%;
    height: 55px;
    padding: 0px 10px;
  } */
}
</style>


// WEBPACK FOOTER //
// src/components/pagefooter.vue